import Link from 'next/link'
import LayoutBasic from '../layouts/layoutBasic'
import { TOKEN, SING_UP, GET_USER_URL } from '../vars'
import { GET, POST, UPOST } from '../helpers'
import { withRouter } from 'next/router'
import { getLocalKeyValue } from '../storage'
import SOCIAL_GOOGLE_LOGIN from '../components/googleSignup'
import { Tabs, Tab } from 'react-bootstrap-tabs';
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { SeoMetaBasic } from '../components/seoMeta'

class SignupCustomer extends React.Component {
  constructor() {
    super()
    this.state = { first_name: '', last_name: '', password1: '', password: '', email: '', submit_success: false, submit_failed: false, submitting: false, msg: '', accept_terms: false, pswdHidden: true }
  }

  showHidePassword = (e) => {
    this.setState({ pswdHidden: !this.state.pswdHidden });
  }

  render() {
    let submitButton = <button type="submit" className="btn btn-primary btn-block">Signup</button>
    if (this.state.submit_failed) {
      submitButton = <button type="submit" className="btn btn-danger btn-block">Failed</button>
    }
    if (this.state.submit_success) {
      submitButton = <button type="submit" className="btn btn-success btn-block">Success</button>
      form = ""
    }
    if (this.state.submitting) {
      submitButton = <button type="submit" className="btn btn-primary btn-block" disabled>Submitting ...</button>
    }
    let form = <div>
      <Formik
        initialValues={{
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          confirmPassword: '',
        }}
        validationSchema={Yup.object().shape({
          firstName: Yup.string()
            .required('First Name is required'),
          lastName: Yup.string()
            .required('Last Name is required'),
          email: Yup.string()
            .email('Email is invalid')
            .required('Email is required'),
          password: Yup.string()
            .min(6, 'Password must be at least 6 characters')
            .required('Password is required'),

        })}
        onSubmit={(fields, { setErrors, setSubmitting, setStatus }) => {
          //alert('SUCCESS!! :-)\n\n' + JSON.stringify(fields))
          setSubmitting(true)
          this.refs.error_block.innerHTML = ""
          let data = {
            first_name: fields.firstName,
            last_name: fields.lastName,
            email: fields.email,
            username: fields.email,
            password: fields.password
          }
          UPOST(SING_UP, data)
            .then((response) => {
              setSubmitting(false)
              setStatus({ submit_success: true, submitting: true })
              this.setState({ submit_success: true })
              this.refs.success_block.innerHTML = "<p>Please check your email to activate your account.</p>"
            }).catch((error) => {
              if (error.response.data.error.username) {
                setSubmitting(false)
                setStatus({ submit_success: false, submitting: false })
                setErrors({ 'email': 'Sorry this email is already registered' })
              }
              else if (error.response.data.error.email) {
                setSubmitting(false)
                setStatus({ submit_success: false, submitting: false })
                setErrors({ 'email': 'Sorry this email is already registered' })
              }
              else {
                setSubmitting(false)
                setStatus({ submit_success: false, submitting: true })
                this.refs.error_block.innerHTML = "<p>Something went wrong, please try agian</p>"
              }
            })
        }}
        render={({ errors, status = { submit_success: null }, touched, values, isSubmitting }) => (
          <Form className="mb-3">
            <div className="row">
              <div className="col">
                <div className="mb-3">
                  <label className='form-label' htmlFor="firstName">First Name</label>
                  <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                  <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                </div>
              </div>
              <div className="col">
                <div className="mb-3">
                  <label className='form-label' htmlFor="lastName">Last Name</label>
                  <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                  <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                </div>
              </div>
            </div>
            <div className="mb-3">
              <label className='form-label' htmlFor="email">Email</label>
              <Field name="email" type="text" className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')} />
              <ErrorMessage name="email" component="div" className="invalid-feedback" />
            </div>
            <div className="mb-3">
              <label className='form-label' htmlFor="password">Password</label>
              <span className="pull-right text-picxy pointer" onClick={this.showHidePassword}>
                <FontAwesomeIcon icon={this.state.pswdHidden ? faEyeSlash : faEye} className="" /> {this.state.pswdHidden ? "Show" : "Hide"}</span>
              <Field name="password" type={this.state.pswdHidden ? 'password' : 'text'} className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')} />
              <ErrorMessage name="password" component="div" className="invalid-feedback" />
            </div>

            <div className="mb-3">
              <button type="submit" className={
                (status.submitting ? (status.submit_success ? 'btn btn-block btn-success' : 'btn btn-block btn-danger') : 'btn btn-primary w-100')}
                disabled={isSubmitting}>{isSubmitting ? "Loading..." : (status.submit_success ? "Signup Success" : "Signup")}</button>
            </div>
          </Form>
        )}
      />
      <p className="mb-1">
        Already have an account ? <Link href="/login-customer"><a><u>Login</u></a></Link>
      </p>
      <div>By signing up, you agree to <Link href="/terms_and_conditions/"><a target="_blank" ><u>terms and conditions</u></a></Link></div>
    </div>


    if (this.state.submit_success) {
      form = ""
    }
    let signup_customer = <div className="container">
      <div className="row justify-content-center mb-2">
        <div className="col-md-5 login">
          <div className="card card-hidden-xs mt-4 mt-sm-0 mb-4">
            <div className="card-body p-0 p-sm-4">
              <h6 className="text-center mb-1">
                Sign up as customer
              </h6>
              <p className="f-18 text-center mb-4">Welcome to Picxy, let's get you started</p>
              <div className="mb-3"><SOCIAL_GOOGLE_LOGIN name="Signup With Google" /></div>
              <h6 className="text-center">
                <p style={{ color: 'red' }} ref="error_block">{this.state.msg}</p>
                <p style={{ color: 'green' }} ref="success_block">{this.state.msg}</p>
              </h6>
              {form}
            </div>
          </div>
        </div>
      </div>
    </div>
    return <LayoutBasic title="Picxy Customer Signup" {...this.props}>
      <SeoMetaBasic name="Picxy Customer Signup" description="Welcome to Picxy, let's get you started" {...this.props} />
      {signup_customer}
    </LayoutBasic>
  }
}

export default withRouter(SignupCustomer)
